export default {
    setBookingForm (state, data) {
        state.bookingForm = data
    },
    setBooking (state, booking) {
        state.booking = booking
    },
    setBookingChangelog (state, booking) {
        state.bookingChangelog = booking
    },
    setIsReturnBooking (state, bool) {
        state.isReturnBooking = bool
    },
    setUnconfirmedUpdate (state, bool) {
        state.isUnConfirmedUpdate = bool
    }
}
